










































import {Vue, Component, Prop, Ref} from 'vue-property-decorator';
import { SelectWings } from "wings-ui-components";
import { Getter } from "vuex-class";

@Component({ components: { SelectWings } })
export default class PushApplicationsRowItem extends Vue {
  @Prop() filteredOptions!: any;
  @Prop() item: any;
  @Prop() isOpen!: any;
  @Ref('validator') validator:any;

  @Getter("pushApplications") applicationsList!: any[];

  private onEdit: boolean = this.isOpen;

  async onSaveItem() {
    const valid = await this.validator.validate();
    if (valid) {
      this.onEdit = false;
      this.$emit('onSaveAction', this.item.name);
    }
  }

  onDeleteAction(){
    this.$emit('onDeleteAction', this.item);
  }
}
